import store from "@/store";

/* Serviços monitorados para buscar novamente o serviço de documentos pendentes */
const monitoredServicesPendingDocuments = [
  'api/v1/partner',
];


export const axiosResponseInterceptor = (api) => {
    api.interceptors.response.use(
        function (response) {
            // Verifica se a URL da requisição corresponde a algum serviço monitorado

            const hasURL = response.config && response.config.url
            const hasUrlMonitored = monitoredServicesPendingDocuments.some(
                service => response.config.url.includes(service)
            )

            const methodToLowercase = response.config.method.toLowerCase();

            const isMethodAllowed = methodToLowercase === 'put' || methodToLowercase === 'patch'

            if (
                hasURL &&
                hasUrlMonitored &&
                isMethodAllowed
            ) {
                console.log('ServicoMonitorado', response.config.url, response.config.method)
                console.log('ServicoMonitorado Chamando fetchDocsPendingDash')

                setTimeout(() => {
                    store.dispatch("home/fetchDocsPendingDash")
                })
            }

            return response.data;
        },
        function (error) {

            const isAuthErrorHandled = store.getters["http/readAuthErrorHandled"];

            /* Se o erro for 401 e ainda não foi tratado, desloga o usuário */
            if (error.response?.status === 401 && !isAuthErrorHandled) {
                store.dispatch('http/setAuthErrorHandled', true)

                store.dispatch("auth/signOutAction").then(() => {
                    location.href = '/'
                });
            }

            return Promise.reject(error.response?.data || error);
        }
    );
}
